module.exports = __webpack_public_path__ + "static/media/bg-signup.3c6f1a5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/SignUpSection/bg-signup.png
// module id = 1001
// module chunks = 0